import { NavBarDesktop } from "components/NavBarDesktop/NavBarDesktop";
import { NavBarMobile } from "components/NavBarMobile/NavBarMobile";

export const NavBar = (props) => {
  return <>{props.isMobile ? <NavBarMobile /> : <NavBarDesktop />}</>;
};
